import { Box, Skeleton, Stack } from "@mui/material";

const ExampleSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        mb: 2,
      }}
    >
      <Box
        sx={{
          py: 1,
          px: 1.5,
          borderBottom: "1px solid rgba(28, 72, 46, 0.45)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Skeleton
          variant="text"
          height={20}
          width="36%"
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
      </Box>
      <Box
        sx={{
          pt: 1.5,
          pb: 1,
          px: 1.5,
        }}
      >
        <Skeleton
          variant="text"
          width="24%"
          height={18}
          sx={{
            mb: 1,
            bgcolor: "background.paper",
          }}
        />
        <Skeleton
          variant="text"
          height={18}
          width="100%"
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="text"
          height={18}
          width="88%"
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="text"
          height={18}
          width="70%"
          sx={{ bgcolor: "background.paper" }}
        />
      </Box>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          py: 0.5,
          px: 1.5,
          justifyContent: "flex-end",
        }}
      >
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
        <Skeleton
          variant="circular"
          width={18}
          height={18}
          sx={{ bgcolor: "background.paper" }}
        />
      </Stack>
    </Box>
  );
};

export default ExampleSkeleton;
